import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import { color } from "src/styles/variables";
import Container from "src/react/layout/container";
import { LinkButton } from "src/react/components/link";

function Promo({
  image,
  floatingImage,
  title,
  description,
  buttonText,
  buttonUrl,
  backgroundColour = "",
  reverse,
  height = 450,
}) {
  const imageWithOptions = `${image}?fm=jpg&fl=progressive${backgroundColour.replace(
    "#",
    "&bg=rgb:"
  )}`;
  return (
    <Wrapper backgroundColour={backgroundColour}>
      <InnerWrapper reverse={reverse} floatingImage={floatingImage}>
        <LazyLoad height={height} offset={100} once>
          <Image
            width={450}
            height={height}
            src={`${imageWithOptions}&w=450`}
            srcSet={`${imageWithOptions}&w=900 2x`}
            floatingImage={floatingImage}
            reverse={reverse}
            alt={title}
          />
        </LazyLoad>
        <Content reverse={reverse} floatingImage={floatingImage}>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <LinkButton tracking="custom" variant="outline" to={buttonUrl}>
            {buttonText}
          </LinkButton>
        </Content>
      </InnerWrapper>
    </Wrapper>
  );
}

Promo.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  backgroundColour: PropTypes.string,
  reverse: PropTypes.bool,
  floatingImage: PropTypes.bool,
  height: PropTypes.number,
};

export default Promo;

const Wrapper = styled.section`
  background-color: ${({ backgroundColour }) =>
    backgroundColour || color.white};
`;

const InnerWrapper = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  padding-top: 30px;
  padding-bottom: ${({ floatingImage }) => (floatingImage ? `0` : `30px`)};
  @media (min-width: 600px) {
    flex-direction: ${({ reverse }) => (reverse ? `row-reverse` : `row`)};
    align-items: center;
  }
`;

const Image = styled.img`
  display: block;
  max-width: 450px;
  height: auto;
  width: 100%;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  ${({ reverse }) => (reverse ? `margin-right: auto;` : `margin-left: auto;`)};
  color: ${color.grey};
  margin-bottom: 20px;
  @media (min-width: 600px) {
    flex: 1;
    max-width: 350px;
  }
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-weight: 400;
  margin-bottom: 30px;
`;
